import { render, staticRenderFns } from "./account-company-opportunities-widget.vue?vue&type=template&id=3b9b231a&"
import script from "./account-company-opportunities-widget.vue?vue&type=script&lang=js&"
export * from "./account-company-opportunities-widget.vue?vue&type=script&lang=js&"
import style0 from "./account-company-opportunities-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports